<template>
  <div class="cameraList w-full h-full relative">
    <div class="icon-search__input mt-5px mb-5px">
      <el-input class="w-full" placeholder="请输入设备名称" v-model="keyWords" clearable>
        <i slot="append" class="el-icon-search cursor-pointer" @click="getIotDevicePagedList"></i>
      </el-input>
    </div>
    <el-table
      ref="tableRef"
      height="calc(100% - 100px)"
      class="mt-20px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column :label="`${$t('名称')}`" show-overflow-tooltip prop="deviceName">
      </el-table-column>
      <el-table-column :label="`${$t('状态')}`" show-overflow-tooltip prop="type" width="50">
        <template slot-scope="scope">
          {{ scope.row.status ? '在线' : '离线' }}
        </template>
      </el-table-column>
      <el-table-column
        :label="`${$t('所属区域')}`"
        show-overflow-tooltip
        prop="areaCode"
      ></el-table-column>
      <el-table-column
        :label="`${$t('异常报警')}`"
        show-overflow-tooltip
        prop="alarmSignal"
      ></el-table-column>
      <el-table-column :label="`${$t('操作')}`" show-overflow-tooltip width="50">
        <template #default="{ row }">
          <div class="w-15 cursor-pointer text-[#00BCC8]" @click="reviewDetail(row)">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="total"
      :current-page.sync="pageNo"
      :page-size.sync="pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="getIotDevicePagedList()"
      :pager-count="5"
    >
    </el-pagination>
    <CameraPicture
      :deviceCode="deviceCode"
      :plid="plid"
      @refresh="refresh"
      v-if="isShowDialog"
      class="w-970px h-500px"
    ></CameraPicture>
  </div>
</template>

<script>
import { WisdomSecurityApi } from '@wiz-api/huizhou2'
import { find } from 'lodash'

const wisdomSecurityApi = new WisdomSecurityApi()
const CameraPicture = () => {
  return import('./cameraPicture')
}

export default {
  name: 'cameraList',
  components: {
    // TitleOne,
    CameraPicture,
  },
  props: {
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      pageSize: 15,
      pageNo: 1,
      isShowDialog: false,
      keyWords: '',
      deviceCode: '',
      plid: '',
    }
  },
  created() {
    this.getIotDevicePagedList()
    this.initOnlyCamera()
  },
  activated() {},
  methods: {
    // 自激活摄像头
    initOnlyCamera() {
      const res = this.checkLabel('CameraList')
      if (!res) {
        return
      }
      this.destroyAllLableOmitOne('CameraList')
    },
    // 检查对象标签是否打开，如果没打开就打开
    checkLabel(value, labelName = '摄像头') {
      const label = find(this.labelList, ['code', value])
      if (!label) {
        this.$message.warning({
          showClose: true,
          message: `没有配置${labelName}标签，请配置`,
        })
        return false
      }
      return true
    },
    // 销毁其余标签
    destroyAllLableOmitOne(value = 'CameraList') {
      // 如果没有打开对应功能标签，则打开
      const filterEvent = new CustomEvent('setLabelChecked', {
        detail: {
          code: value,
          checked: true,
          isCloseAllOmitOne: true,
        },
      })
      window.dispatchEvent(filterEvent)
    },
    async getIotDevicePagedList() {
      const [err, res] = await wisdomSecurityApi.getIotDevicePagedList({
        body: {
          maxResultCount: this.pageSize,
          skipCount: (this.pageNo - 1) * this.pageSize,
          DeviceType: [1],
          areaCode: '',
          keyWords: this.keyWords,
        },
      })
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
    },
    reviewDetail(item) {
      this.isShowDialog = true
      this.deviceCode = item.deviceCode
      this.plid = item.plid
    },
    refresh() {
      this.isShowDialog = false
    },
    currentChange() {},
  },
}
</script>
<style lang="scss" scoped></style>
